import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Services, Text, TextInput, DateInput, Theme } from '@simplybenefits/sb-ui-library';
import Grid from "@mui/material/Grid";
import { Cancel as CancelIcon } from '@mui/icons-material';

class ExtractedTeethModal extends PureComponent {
    state = {
        extractedTeeth: this.props.extractedTeeth ? this.props.extractedTeeth : []
    };

    _saveData = () => {
        this.props.saveData(this.state.extractedTeeth, 'extractedTeeth');
    };

    _validateForm = async () => {
        let isValid = true;

        const promises = this.state.extractedTeeth.map(async (extractedTooth, index) => {
            const toothNumberError = await Services.validateInput('checkEmpty', extractedTooth.toothNumber);
            const extractionDateError = this.props.isPredetermination ? null : await Services.validateInput('birthdate', extractedTooth.extractionDate);

            this.setState({
                [`toothNumberError${ index }`]: toothNumberError,
                [`extractionDateError${ index }`]: extractionDateError
            });

            if (
                toothNumberError ||
                extractionDateError
            ) {
                isValid = false;
                return false;
            }

            return true;
        });

        await Promise.all(promises);
        return isValid;
    };

    _next = async () => {
        const isValid = await this._validateForm();

        if (!isValid) {
            return;
        }

        await this._saveData();
        this.props.next();
    };

    _handleArrayItemChange = (type, index, key, e) => {
        this.setState({
            [type]: this.state[type].map((item, i) => {
                if (index !== i) {
                    return item;
                }

                return {
                    ...item,
                    [key]: e.target.value
                };
            })
        });
    };

    _createExtractedTooth = () => {
        const extractedTooth = {
            toothNumber: '',
            extractionDate: ''
        };

        this.setState({
            extractedTeeth: [ ...this.state.extractedTeeth, extractedTooth ]
        });
    };

    _removeTooth = (index) => {
        this.setState({
            extractedTeeth: this.state.extractedTeeth.filter((item, i) => i !== index)
        });
    };

    render() {
        const styles = {
            container: {
                flex: 1,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                marginBottom: 5
            },
            details: {
                flex: 1,
                flexDirection: 'column',
                marginBottom: 20
            },
            procedureBlock: {
        
            }
        };

        return (
            <Modal
                medium
                testid="submit-claim-modal"
                aria-labelledby="Extracted Teeth"
                open={true}
                title={ this.props.title }
                primaryButton={{
                    label: "Next",
                    onClick: this._next
                }}
                onClose={ this.props.onClose }
                loader={ this.props.loader }
                onBack={ this.props.onBack }
            >
                <Text mediumLarge>
                        Extracted Teeth
                </Text>
                {
                    this.state.extractedTeeth.map((extractedTooth, index) => (
                        <div style={ styles.procedureBlock }>
                            <Text medium bold color={ Theme.colors.skyBlue } margin="10px 0">
                                    Extracted Tooth { index + 1 }

                                <CancelIcon
                                    onClick={ () => this._removeTooth(index) }
                                    style={{ cursor: 'pointer', paddingTop: 10 }}
                                />
                            </Text>

                            <Grid
                                container
                                spacing={1}
                            >
                                <Grid item xs={12} sm={6} >
                                    <TextInput
                                        label="Tooth Number"
                                        variant="outlined"
                                        value={ extractedTooth.toothNumber }
                                        onChange={ (e) => this._handleArrayItemChange('extractedTeeth', index, 'toothNumber', e) }
                                        required
                                        fullWidth
                                        error={Boolean(this.state[`toothNumberError${ index }`])}
                                        helperText={this.state[`toothNumberError${ index }`]}
                                        margin="0"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} >
                                    <DateInput
                                        label="Extraction Date"
                                        variant="outlined"
                                        value={ extractedTooth.extractionDate }
                                        onChange={ (e) => this._handleArrayItemChange('extractedTeeth', index, 'extractionDate', e) }
                                        disabled={this.props.isPredetermination}
                                        required
                                        fullWidth
                                        error={Boolean(this.state[`extractionDateError${ index }`])}
                                        helperText={this.state[`extractionDateError${ index }`]}
                                        margin="0"
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    ))
                }

                <Button
                    onClick={this._createExtractedTooth}
                    transparent
                    fullWidth
                    customStyle={{ margin: "10px 0 20px 0", width: "100%" }}
                >
                        ADD EXTRACTED TOOTH
                </Button>

                <Text light tiny>
                    By submitting this claim I agree to the Simply Benefits Terms of Service.
                </Text>
            </Modal>
        );
    }
}

export default connect()(ExtractedTeethModal);